export default class UsersAlertPendingService {
    [x: string]: any; 
 	 static $inject = ['PaymentStatusService','$timeout','$window','$state'];
    constructor(PaymentStatusService, $timeout, $window, $state) {
        this.PaymentStatusService = PaymentStatusService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$state = $state;
    }

    isPending() {
        return this.pending;
    }

    getStatusPayment() {
        this.request = this.PaymentStatusService.get((res) => {
            this.beforePending = this.pending;
            this.pending = res.pending;
            if (this.enableTimer && this.pending) {
                this.$timeout(() => this.getStatusPayment(), 3000);
            } else if (this.beforePending && !this.pending) {
                this.$state.go(this.$state.current.name, Object.assign(this.$state.params, {changedPlan: true}), {reload: 'app.users'});
            }
        })
    }

    isLocalhost() {
        return this.$window.location.hostname === 'localhost';
    }

    onDestroy() {
        if (!this.isLocalhost()) {
            this.enableTimer = false;
            this.beforePending = false;
            this.pending = false;
            this.request = null;
        }
    }

    onInit() {
        if (!this.isLocalhost() && !this.request) {
            this.enableTimer = true;
            this.getStatusPayment();
        }
    }

    getRequest() {
        return this.request.$promise;
    }
}
